module.exports = __webpack_public_path__ + "static/media/earth2.5e74a8b1.jpg";